// 관리자 공지 발송 API 래퍼.

import type { AdminBroadcastInput } from "@oo/shared";
import { api } from "@/api/client.ts";

// 전체 사용자에게 공지/이벤트 발송 (알림센터 + 푸시). 반환: 수신자 수.
export async function broadcastNotification(input: AdminBroadcastInput): Promise<number> {
  const data = await api.post<{ recipients: number }>("/admin/notifications", input);
  return data.recipients;
}
